// extracted by mini-css-extract-plugin
export default {"paymentSection":"l7-z","disabled":"m7-z"};